import React, {Component} from "react";
import {observer, inject} from "mobx-react";

import {RIGHT_SYMBOL} from "../../../utils/constant";
import "../common.css";

@inject("navbar")
@observer
class LinkToFootToggle extends Component {
  handleClick = () => {
    const {isLinkToFoot} = this.props.navbar;
    this.props.navbar.setLinkToFoot(!isLinkToFoot);
  };

  render() {
    return (
      <div id="nice-menu-link-to-foot-toggle" className="nice-menu-item" onClick={this.handleClick}>
        <span>
          <span className="nice-menu-flag">{this.props.navbar.isLinkToFoot && <span>{RIGHT_SYMBOL}</span>}</span>
          <span className="nice-menu-name">复制时外链转脚注</span>
        </span>
      </div>
    );
  }
}

export default LinkToFootToggle;
